import { createStackNavigator } from "@react-navigation/stack"
import type { ContactScheduleAnswerStackParamList } from "src/types.d"

export const ContactScheduleAnswerStack = createStackNavigator<ContactScheduleAnswerStackParamList>()
